export enum SettingsType {
  APP = 'app',
  TIME_RATE = 'time_rate',
}

export enum SettingsKey {
  BATCH_NORMALIZATION = 'batch_normalization',
  PIPELINE = 'pipeline',
}
